export function Empty({ text }: { text: string }) {
  return <p className="empty">{text}</p>;
}
